import styled, { css } from "styled-components";
import { ReactSVG } from "react-svg";

export const Container = styled.div`
  max-width: 90%;
  margin: 0 auto;
`;

export const Card = styled.div`
  background: #fff;

  .boxSearch {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin: 25px auto;
  }

  .lupa {
    position: absolute;
    width: 26.1px;
    height: 26.1px;
    padding: 6.3px 1.8px 3.8px 3.3px;
    margin: 0 7px;
    z-index: 9;
  }

  .boxSearch > input {
    position: relative;
    width: 40%;
    height: 39px;
    padding: 6px 8px 6px 35px;
    border-radius: 6px;
    border: solid 1px #707070;
    background-color: #ffffff;

    @media only screen and (max-width: 500px) {
      width: 50%;
      height: 30px;
    }
  }

  .boxSearch Button {
    width: 170px;
    height: 30px;
    font-size: 14px !important;
    margin-left: 10px;
    padding: 4px 17px;
    border-radius: 6px;
    background-color: #00a2e0;

    @media only screen and (max-width: 500px) {
      width: 170px;
      height: 30px;
      font-size: 12px !important;
    }
  }
  @media only screen and (max-width: 855px) {
    .boxSearch {
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
  }
`;

export const CardHeader = styled.div`
  padding: 0.2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: solid 2px #bbbbbb;

  .border {
    border-left: 2px solid #bbbbbb;
    padding: 10px;
    color: #ccc;
    font-size: 1.3rem;
    width: 37%;
    height: auto;
    text-align: center;
  }

  @media only screen and (max-width: 500px) {
    .border {
      padding: 0;
      text-align: center;
      width: 44%;
    }
    span {
      font-size: 1.2rem;
    }
  }
  @media (min-width: 1600px) {
    .border {
      width: 35%;
    }
  }
`;

export const CardBody = styled.div`
  margin-top: 30px !important;
`;

export const Custumer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 0.7rem;
  border-bottom: solid 1px #707070;

  .iconService {
    display: flex;
    align-items: center;
    cursor: pointer;
  }
`;

export const Info = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  img {
    /* margin-right: 1rem; */
    width: 24.7px;
    height: 24.7px;
    margin: 0px 15px 0px 0px;
    object-fit: contain;
  }
  .dataCard {
    display: flex;
    flex-direction: column;
  }

  h4 {
    height: 15px;
    margin: 8px 35px 2px 5px;
    opacity: 0.9;
    font-family: Roboto;
    font-size: 13px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.15;
    -webkit-letter-spacing: normal;
    -moz-letter-spacing: normal;
    -ms-letter-spacing: normal;
    letter-spacing: normal;
    text-align: left;
    color: #747576;
  }

  .h4-info {
    color: #000000;
  }

  @media (max-width: 860px) {
    .h4-info {
      /* width: 10ch; */
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      height: 1em;
    }
  }
`;
